import { useState, useEffect, useRef } from 'react';
import './App.css';

function App() {
  const observerRef = useRef(null);
  const [formData, setFormData] = useState({ nombre: '', email: '', mensaje: '' });
  const [estado, setEstado] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEstado('enviando');
    try {
      const res = await fetch('https://an45k74obl.execute-api.us-east-1.amazonaws.com/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      if (res.ok) {
        setEstado('ok');
        setFormData({ nombre: '', email: '', mensaje: '' });
      } else {
        setEstado('error');
      }
    } catch {
      setEstado('error');
    }
  };

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.reveal').forEach((el) => {
      observerRef.current.observe(el);
    });

    return () => observerRef.current.disconnect();
  }, []);

  return (
    <div className="App">

      <header className="hero">
        <div className="hero-inner">
          <span className="hero-tag">Cloud &amp; AWS</span>
          <h1>Yucami</h1>
          <p className="hero-sub">
            AWS Certified Solutions Architect Associate
          </p>
          <nav className="hero-nav">
            <a href="#sobre-mi">Sobre mi</a>
            <a href="#proyectos">Proyectos</a>
            <a href="#contacto">Contacto</a>
          </nav>
        </div>
        <div className="hero-scroll">
          <span></span>
        </div>
      </header>

      <section id="sobre-mi" className="seccion reveal">
        <div className="seccion-inner">
          <span className="seccion-label">01 — Sobre mi</span>
          <h2>Profesional en transicion hacia el cloud</h2>
          <p>
            AWS Certified Solutions Architect Associate.
            Aprendiendo cloud desde cero con proyectos reales en AWS.
            En transicion desde un sector donde las personas
            y los procesos importan.
          </p>
        </div>
      </section>

      <section id="proyectos" className="seccion seccion-dark">
        <div className="seccion-inner">
          <span className="seccion-label light">02 — Proyectos</span>
          <h2 className="light">Arquitecturas reales en AWS</h2>
          <div className="proyectos-grid">

            <div className="proyecto-card reveal">
              <div className="card-numero">01</div>
              <h3>Portfolio estatico</h3>
              <p>
                Sitio web desplegado con bucket privado en S3, CloudFront
                como CDN con OAC, HTTPS con ACM y dominio en Route 53.
              </p>
              <div className="card-tags">
                <span className="tag">S3</span>
                <span className="tag">CloudFront</span>
                <span className="tag">Route 53</span>
                <span className="tag">ACM</span>
              </div>
              <a href="https://github.com/yucami/mi-portfolio-aws"
                className="card-link"
                target="_blank"
                rel="noreferrer"
              >
                Ver en GitHub
              </a>
            </div>

            <div className="proyecto-card reveal">
              <div className="card-numero">02</div>
              <h3>Formulario serverless</h3>
              <p>
                Formulario de contacto con funcion Lambda en Python,
                endpoint en API Gateway y envio de email con SES.
                Logs estructurados en CloudWatch.
              </p>
              <div className="card-tags">
                <span className="tag">Lambda</span>
                <span className="tag">API Gateway</span>
                <span className="tag">SES</span>
                <span className="tag">CloudWatch</span>
              </div>
              <a href="https://github.com/Yucami/proyecto2-serverless-form"
                className="card-link"
                target="_blank"
                rel="noreferrer"
              >
                Ver en GitHub
              </a>
            </div>

            <div className="proyecto-card reveal">
              <div className="card-numero">03</div>
              <h3>Infrastructure as Code</h3>
              <p>
                Plantillas CloudFormation que replican la infraestructura de los
                Proyectos 1 y 2. Bucket S3, CloudFront, Lambda y API Gateway como codigo.
              </p>
              <div className="card-tags">
                <span className="tag">CloudFormation</span>
                <span className="tag">IaC</span>
                <span className="tag">YAML</span>
              </div>
              <a href="https://github.com/Yucami/proyecto3-iac"
                className="card-link"
                target="_blank"
                rel="noreferrer"
              >
                Ver en GitHub
              </a>
            </div>

            <div className="proyecto-card reveal">
              <div className="card-numero">04</div>
              <h3>Monitoring con EC2</h3>
              <p>
                Servidor Nginx en EC2 con monitorizacion completa en CloudWatch.
                Metricas, logs, alarmas y dashboard. Acceso sin SSH con Session Manager.
              </p>
              <div className="card-tags">
                <span className="tag">EC2</span>
                <span className="tag">CloudWatch</span>
                <span className="tag">Nginx</span>
                <span className="tag">SNS</span>
                <span className="tag">SSM</span>
              </div>
              <a href="https://github.com/Yucami/proyecto4-monitoring"
                className="card-link"
                target="_blank"
                rel="noreferrer"
              >
                Ver en GitHub
              </a>
            </div>

            <div className="proyecto-card reveal">
              <div className="card-numero">05</div>
              <h3>Full Serverless App</h3>
              <p>
                "UñaPezuña" - Aplicacion de reservas para negocio real de manicura en Madrid.
                Autenticacion con Cognito, API Gateway HTTP, 17 funciones Lambda en Python,
                DynamoDB, SQS con DLQ y emails transaccionales con Resend.
                Frontend React desplegado en S3 + CloudFront con dominio propio.
              </p>
              <div className="card-tags">
                <span className="tag">Lambda</span>
                <span className="tag">DynamoDB</span>
                <span className="tag">Cognito</span>
                <span className="tag">API Gateway</span>
                <span className="tag">SQS</span>
                <span className="tag">S3</span>
                <span className="tag">CloudFront</span>
              </div>
              <a href="https://unapezuna.es"
                className="card-link"
                target="_blank"
                rel="noreferrer"
              >
                Ver proyecto
              </a>
              <a href="https://github.com/yucami/proyecto5-unapezuna"
                className="card-link"
                target="_blank"
                rel="noreferrer"
              >
                Ver en GitHub
              </a>
            </div>

            <div className="proyecto-card reveal">
              <div className="card-numero">06</div>
              <h3>CI/CD Pipeline</h3>
              <p>
                Deploy automatico del Proyecto 5 con GitHub Actions.
                Cada push a main ejecuta el build, sincroniza a S3 e invalida
                CloudFront automaticamente. Usuario IAM con permisos minimos
                y credenciales como secrets de GitHub.
              </p>
              <div className="card-tags">
                <span className="tag">GitHub Actions</span>
                <span className="tag">S3</span>
                <span className="tag">CloudFront</span>
                <span className="tag">IAM</span>
              </div>
              <a href="https://github.com/Yucami/proyecto5-unapezuna/blob/main/.github/workflows/deploy.yml"
                className="card-link"
                target="_blank"
                rel="noreferrer"
              >
                Ver workflow
              </a>
            </div>

            <div className="proyecto-card reveal">
              <div className="card-numero">07</div>
              <h3>Infraestructura como Codigo con Terraform</h3>
              <p>
                Toda la infraestructura serverless de UñaPezuña codificada en Terraform.
                70 recursos importados desde produccion sin interrumpir el servicio:
                IAM, DynamoDB, Cognito, SQS, S3, 17 Lambdas y API Gateway HTTP.
              </p>
              <div className="card-tags">
                <span className="tag">Terraform</span>
                <span className="tag">IaC</span>
                <span className="tag">Lambda</span>
                <span className="tag">DynamoDB</span>
                <span className="tag">Cognito</span>
                <span className="tag">API Gateway</span>
              </div>
              <a href="https://github.com/Yucami/proyecto7-unapezuna-terraform"
                className="card-link"
                target="_blank"
                rel="noreferrer"
              >
                Ver en GitHub
              </a>
            </div>

            <div className="proyecto-card reveal">
              <div className="card-numero">08</div>
              <h3>Analytics Pipeline</h3>
              <p>
                Pipeline serverless de analytics sobre datos de produccion de UñaPezuña.
                Export de DynamoDB a S3, catalogacion con AWS Glue y consultas SQL
                con Amazon Athena. Sin servidores ni bases de datos adicionales.
              </p>
              <div className="card-tags">
                <span className="tag">Athena</span>
                <span className="tag">Glue</span>
                <span className="tag">DynamoDB</span>
                <span className="tag">S3</span>
              </div>
              <a href="https://github.com/Yucami/proyecto8-unapezuna-analytics"
                className="card-link"
                target="_blank"
                rel="noreferrer"
              >
                Ver en GitHub
              </a>
            </div>

            <div className="proyecto-card reveal">
              <div className="card-numero">09</div>
              <h3>Recordatorios automaticos con SNS</h3>
              <p>
                Sistema de recordatorios 24h antes de cada cita para UñaPezuña.
                Lambda disparada por EventBridge Scheduler cada dia a las 11:00.
                Email via Resend y SMS via Amazon SNS. Logs de entrega en CloudWatch.
              </p>
              <div className="card-tags">
                <span className="tag">SNS</span>
                <span className="tag">EventBridge</span>
                <span className="tag">Lambda</span>
                <span className="tag">DynamoDB</span>
                <span className="tag">CloudWatch</span>
              </div>
              <a href="https://github.com/Yucami/proyecto9-sns-recordatorios"
                className="card-link"
                target="_blank"
                rel="noreferrer"
              >
                Ver en GitHub
              </a>
            </div>
            <div className="proyecto-card reveal">
              <div className="card-numero">10</div>
              <h3>Docker + Amazon ECS</h3>
              <p>
                Servicio de procesamiento de imagenes para UñaPezuña contenerizado con Docker,
                almacenado en ECR y desplegado en ECS Fargate. Redimensiona y aplica watermark
                a las fotos del catalogo. Opera a 0 tareas en reposo (~$0/mes).
              </p>
              <div className="card-tags">
                <span className="tag">Docker</span>
                <span className="tag">ECS Fargate</span>
                <span className="tag">ECR</span>
                <span className="tag">S3</span>
                <span className="tag">CloudWatch</span>
              </div>
              <a href="https://github.com/Yucami/proyecto10-unapezuna-docker"
                className="card-link"
                target="_blank"
                rel="noreferrer"
              >
                Ver en GitHub
              </a>
            </div>

            <div className="proyecto-card reveal">
              <div className="card-numero">11</div>
              <h3>Kubernetes + Amazon EKS</h3>
              <p>
                Migracion del servicio de procesamiento de imagenes del P10 a Kubernetes
                usando Amazon EKS. Cluster gestionado por AWS con node group EC2 t3.small,
                Service tipo LoadBalancer y misma imagen Docker de ECR. Todo desplegado
                desde AWS CloudShell sin instalaciones locales.
              </p>
              <div className="card-tags">
                <span className="tag">Kubernetes</span>
                <span className="tag">EKS</span>
                <span className="tag">Docker</span>
                <span className="tag">ECR</span>
                <span className="tag">S3</span>
              </div>
              <a href="https://github.com/Yucami/proyecto11-unapezuna-eks"
                className="card-link"
                target="_blank"
                rel="noreferrer"
              >
                Ver en GitHub
              </a>
            </div>

          </div>
        </div>
      </section>

      <section id="contacto" className="seccion reveal">
        <div className="seccion-inner">
          <span className="seccion-label">03 — Contacto</span>
          <h2>Hablemos</h2>
          <p>Disponible para oportunidades en cloud y AWS.</p>
          <div className="contacto-links">
            <a href="mailto:contacto@yucami.com" className="contacto-item">
              <span className="contacto-icon">✉</span>
              contacto@yucami.com
            </a>
            <a href="https://linkedin.com/in/miproximoperfil"
              target="_blank"
              rel="noreferrer"
              className="contacto-item"
            >
              <span className="contacto-icon">in</span>
              LinkedIn
            </a>
            <a href="https://github.com/yucami"
              target="_blank"
              rel="noreferrer"
              className="contacto-item"
            >
              <span className="contacto-icon">gh</span>
              GitHub
            </a>
          </div>

          <form className="contacto-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="nombre"
              placeholder="Tu nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Tu email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="mensaje"
              placeholder="Tu mensaje"
              rows="5"
              value={formData.mensaje}
              onChange={handleChange}
              required
            />
            <button type="submit" disabled={estado === 'enviando'}>
              {estado === 'enviando' ? 'Enviando...' : 'Enviar mensaje'}
            </button>
            {estado === 'ok' && <p className="form-ok">Mensaje enviado correctamente</p>}
            {estado === 'error' && <p className="form-error">Error al enviar. Intentalo de nuevo</p>}
          </form>

        </div>
      </section>

      <footer className="footer">
        <p>2026 Yucami · Desplegado en AWS</p>
      </footer>

    </div>
  );
}

export default App;